import _ from 'lodash'
import { RESET_PASSWORD } from 'actions'

const initialState = {
  email: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD: {
      return _.merge({}, state, {
        email: action.email,
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/resetPassword/index.js